import { INSTALLATION_ID_HEADER_NAME } from '$extensionSrc/utils/enums'

const ACCESS_CSRF_TOKEN_NAME = 'csrf_access_jwt'
const INSTALLATION_ID_COOKIE_NAME = 'installation_id'
const CSRF_HEADER = 'X-CSRF-TOKEN'

function getCookieFromDocument(name: string): string | null {
  const cookie = document.cookie
    .split(';')
    .find((c) => c.trim().startsWith(`${name}=`))

  if (!cookie) {
    return null
  }

  return cookie.split('=')[1]
}

export function getJwtAccessCsrfHeader(): [string | null, string | null] {
  const token = getCookieFromDocument(ACCESS_CSRF_TOKEN_NAME)
  if (!token) {
    return [null, null]
  }

  return [CSRF_HEADER, token]
}

declare global {
  interface Window {
    csrfToken?: string
  }
}

export function getUnauthCsrfHeader(): [string, string] | [null, null] {
  const token = window?.csrfToken

  if (!token) {
    return [null, null]
  }

  return [CSRF_HEADER, token]
}

export function getInstallationId(): string | null {
  const installationIdCookie = getCookieFromDocument(
    INSTALLATION_ID_COOKIE_NAME,
  )
  if (!installationIdCookie) {
    return null
  }

  return installationIdCookie
}

export function authFetch(request: Request) {
  if (request.method === 'POST') {
    const [jwtHeaderName, jwtHeaderValue] = getJwtAccessCsrfHeader()

    if (jwtHeaderName && jwtHeaderValue) {
      request.headers.set(jwtHeaderName, jwtHeaderValue)
    } else {
      const [csrfHeaderName, csrfHeaderValue] = getUnauthCsrfHeader()

      if (csrfHeaderName && csrfHeaderValue) {
        request.headers.set(csrfHeaderName, csrfHeaderValue)
      }
    }
  }

  const installationId = getInstallationId()
  if (installationId) {
    request.headers.set(INSTALLATION_ID_HEADER_NAME, installationId)
  }

  return fetch(request)
}
